import { ListView } from './List'

export const reassign = {
  name: 'reassign',
  list: ListView,
}
